<div class="profile-integrations" [busyIf]="loading || connecting">
    <div class="profile-integrations__header">
        <h6><b>{{ 'IntegrationWithApps' | localize }}</b></h6>
        <small>
            {{ 'IntegrationWithAppsDescription' | localize }}
        </small>
    </div>

    <div class="profile-integrations__grid">
        <div class="integration-card" *ngFor="let item of catalog; trackBy: trackByProvider">
            <div class="integration-card__brand">
                <span class="integration-card__icon-frame">
                    <img class="integration-card__icon"
                         [class.integration-card__icon--outlook]="item.provider === provider.Outlook"
                         [class.integration-card__icon--monochrome]="item.provider === provider.ChatGpt ||
                                                                    item.provider === provider.GitHubCopilot ||
                                                                    item.provider === provider.Cursor"
                         [src]="item.iconUrl"
                         [alt]="item.name" />
                </span>
                <div class="integration-card__title-row">
                    <h6 class="integration-card__title">{{ item.name  }}</h6>
                    <span class="integration-card__linked"
                          *ngIf="readOnly && isConnected(item) && !item.isComingSoon">
                        <span class="integration-card__linked-dot"></span>
                        {{ 'Linked' | localize }}
                    </span>
                </div>
            </div>
            <p class="integration-card__description">{{ item.description }}</p>

            <div class="integration-card__usage"
                 *ngIf="!readOnly && showsTokenUsage(item) && item.connection && (item.connection.tokensUsed != null || item.connection.tokensAvailable != null)">
                <small *ngIf="item.connection.tokensAvailable != null">
                    {{ 'IntegrationsTokensUsed' | localize }}: {{ item.connection.tokensUsed ?? '-' }}
                    /
                    {{ 'IntegrationsTokensAvailable' | localize }}: {{ item.connection.tokensAvailable }}
                </small>
                <small *ngIf="item.connection.tokensAvailable == null">
                    {{ 'IntegrationsTokensUsed' | localize }}: {{ item.connection.tokensUsed ?? 0 }}
                </small>
            </div>

            <div class="integration-card__usage" *ngIf="!readOnly && isDevOps(item) && item.connectedProjectCount">
                <small>
                    {{ 'IntegrationsDevOpsConnectedProjects' | localize: item.connectedProjectCount }}
                </small>
            </div>

            <div class="integration-card__usage" *ngIf="isOutlook(item) && isConnected(item)">
                <small *ngIf="item.connectedAccountCount" class="d-block">
                    {{ 'IntegrationsOutlookConnectedAccounts' | localize: item.connectedAccountCount }}
                </small>
                <small *ngIf="item.connection?.externalAccountEmail" class="d-block">
                    {{ 'IntegrationsOutlookActiveAccount' | localize: item.connection.externalAccountEmail }}
                </small>
            </div>

            <div class="integration-card__usage" *ngIf="isKeka(item) && isConnected(item) && item.connection?.linkedByUserName">
                <small>
                    {{ 'IntegrationsLinkedBy' | localize: item.connection.linkedByUserName }}
                </small>
            </div>

            <div class="integration-card__action">
                <span class="integration-card__coming-soon"
                      *ngIf="item.isComingSoon">
                    {{ 'ComingSoon' | localize }}
                </span>

                <!-- DevOps is per project, so Link stays available to wire up further projects. -->
                <ng-container *ngIf="!item.isComingSoon && isDevOps(item)">
                    <button type="button"
                            class="btn btn-sm integration-card__button btn-outline-primary"
                            [class.integration-card__button--icon]="isConnected(item)"
                            [attr.aria-label]="isConnected(item) ? ('IntegrationsLink' | localize) : null"
                            [attr.title]="isConnected(item) ? ('IntegrationsLink' | localize) : null"
                            (click)="openConfiguration(item)">
                        <ng-container *ngIf="isConnected(item); else devopsLinkLabel">+</ng-container>
                        <ng-template #devopsLinkLabel>{{ 'IntegrationsLink' | localize }}</ng-template>
                    </button>
                    <button type="button"
                            class="btn btn-sm integration-card__button btn-outline-danger"
                            *ngIf="isConnected(item)"
                            (click)="disconnect(item)">
                        {{ 'IntegrationsDelink' | localize }}
                    </button>
                </ng-container>

                <!-- Outlook supports multiple mailboxes; + adds another, Delink opens manage drawer. -->
                <ng-container *ngIf="!item.isComingSoon && isOutlook(item)">
                    <button type="button"
                            class="btn btn-sm integration-card__button btn-outline-primary"
                            [class.integration-card__button--icon]="isConnected(item)"
                            [attr.aria-label]="isConnected(item) ? ('IntegrationsLink' | localize) : null"
                            [attr.title]="isConnected(item) ? ('IntegrationsLink' | localize) : null"
                            (click)="openConfiguration(item)">
                        <ng-container *ngIf="isConnected(item); else outlookLinkLabel">+</ng-container>
                        <ng-template #outlookLinkLabel>{{ 'IntegrationsLink' | localize }}</ng-template>
                    </button>
                    <button type="button"
                            class="btn btn-sm integration-card__button btn-outline-danger"
                            *ngIf="isConnected(item)"
                            (click)="disconnect(item)">
                        {{ 'IntegrationsDelink' | localize }}
                    </button>
                </ng-container>

                <button type="button"
                        class="btn btn-sm integration-card__button btn-outline-danger"
                        *ngIf="!item.isComingSoon && item.canManage !== false && !isDevOps(item) && !isOutlook(item) && isConnected(item)"
                        (click)="disconnect(item)">
                    {{ 'IntegrationsDelink' | localize }}
                </button>
                <button type="button"
                        class="btn btn-sm integration-card__button btn-outline-primary"
                        *ngIf="!item.isComingSoon && item.canManage !== false && !isDevOps(item) && !isOutlook(item) && !isConnected(item)"
                        (click)="openConfiguration(item)">
                    {{ 'IntegrationsLink' | localize }}
                </button>
            </div>
        </div>
    </div>
</div>

<p-drawer *ngIf="!readOnly"
          [(visible)]="isConfigurationOpen"
          [blockScroll]="true"
          [dismissible]="!connecting"
          [closeOnEscape]="!connecting"
          position="right"
          appendTo="body"
          styleClass="integration-config-drawer"
          (onHide)="closeConfiguration()">
    <div class="integration-drawer__header">
        <h5>{{ 'IntegrationsConfiguration' | localize }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeConfiguration()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="integration-drawer__body">
        <ng-container *ngIf="selectedItem?.provider === provider.Outlook">
            <p class="text-muted">
                {{ (outlookManageMode
                    ? 'IntegrationsOutlookManageHint'
                    : (isConnected(selectedItem) ? 'IntegrationsOutlookAddAnotherHint' : 'IntegrationsOutlookExistingFlow'))
                    | localize }}
            </p>

            <div class="outlook-accounts" *ngIf="outlookAccounts?.length">
                <div class="outlook-accounts__row"
                     *ngFor="let account of outlookAccounts">
                    <div class="outlook-accounts__meta">
                        <div class="outlook-accounts__email">{{ account.email }}</div>
                        <small class="text-muted" *ngIf="account.name">{{ account.name }}</small>
                        <span class="badge badge-success ml-1" *ngIf="isOutlookAccountActive(account)">
                            {{ 'IntegrationsOutlookActive' | localize }}
                        </span>
                    </div>
                    <div class="outlook-accounts__actions">
                        <button type="button"
                                class="btn btn-sm btn-outline-primary"
                                *ngIf="!isOutlookAccountActive(account)"
                                [disabled]="connecting"
                                (click)="setActiveOutlookAccount(account)">
                            {{ 'IntegrationsOutlookSetActive' | localize }}
                        </button>
                        <button type="button"
                                class="btn btn-sm btn-outline-danger"
                                [disabled]="connecting"
                                (click)="unlinkOutlookAccount(account)">
                            {{ 'IntegrationsOutlookUnlinkAccount' | localize }}
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="isDevOps(selectedItem)">
            <p class="text-muted">
                {{ (devOpsDisconnectMode ? 'IntegrationsDevOpsDelinkHint' : 'IntegrationsDevOpsHint') | localize }}
            </p>

            <div class="form-group">
                <label>
                    {{ 'Project' | localize }}
                    <span class="text-danger">*</span>
                </label>
                <select class="form-control rounded-0"
                        [(ngModel)]="devOpsSelectedProjectId"
                        (ngModelChange)="onDevOpsProjectChange()">
                    <option [ngValue]="undefined">{{ 'IntegrationsDevOpsSelectProject' | localize }}</option>
                    <option *ngFor="let devOpsProject of devOpsProjectOptions" [ngValue]="devOpsProject.projectId">
                        {{ devOpsProject.projectName }}
                    </option>
                </select>
            </div>

            <ng-container *ngIf="!devOpsDisconnectMode">
                <div class="form-group">
                    <label>
                        {{ 'IntegrationsDevOpsProjectName' | localize }}
                        <span class="text-danger">*</span>
                    </label>
                    <input class="form-control rounded-0"
                           type="text"
                           autocomplete="off"
                           [(ngModel)]="devOpsProjectName"
                           [placeholder]="'IntegrationsDevOpsProjectNamePlaceholder' | localize" />
                </div>

                <div class="form-group">
                    <label>
                        {{ 'IntegrationsDevOpsProjectUrl' | localize }}
                        <span class="text-danger">*</span>
                    </label>
                    <input class="form-control rounded-0"
                           type="text"
                           autocomplete="off"
                           [(ngModel)]="devOpsProjectUrl"
                           [placeholder]="'IntegrationsDevOpsProjectUrlPlaceholder' | localize" />
                </div>

                <div class="form-group mb-0">
                    <label>
                        {{ 'IntegrationsDevOpsPersonalAccessToken' | localize }}
                        <span class="text-danger">*</span>
                    </label>
                    <input class="form-control rounded-0"
                           type="password"
                           autocomplete="off"
                           [(ngModel)]="devOpsPersonalAccessToken"
                           [placeholder]="'IntegrationsDevOpsPersonalAccessTokenPlaceholder' | localize" />
                </div>
            </ng-container>
        </ng-container>

        <div class="form-group" *ngIf="isKeka(selectedItem)">
            <label>{{ 'Users' | localize }}</label>
            <ng-select [items]="kekaUsers"
                       [multiple]="true"
                       bindLabel="fullName"
                       bindValue="id"
                       [clearSearchOnAdd]="true"
                       [closeOnSelect]="false"
                       dropdownPosition="bottom"
                       appendTo="body"
                       [(ngModel)]="kekaSelectedUserIds"
                       [ngModelOptions]="{ standalone: true }"
                       [loading]="kekaUsersLoading"
                       [placeholder]="'SelectMembers' | localize">
            </ng-select>
        </div>

        <div class="form-group" *ngIf="selectedItem?.provider !== provider.Outlook && !isDevOps(selectedItem) && !isKeka(selectedItem)">
            <label>
                {{ 'IntegrationsLicenseAllocation' | localize }}
                <span class="text-danger">*</span>
            </label>
            <div class="mt-2">
                <label class="mr-4">
                    <input type="radio"
                           name="licenseAllocation"
                           [value]="allocation.MyCompany"
                           [(ngModel)]="licenseAllocation" />
                    {{ 'IntegrationsMyCompany' | localize }}
                </label>
                <label>
                    <input type="radio"
                           name="licenseAllocation"
                           [value]="allocation.Client"
                           [(ngModel)]="licenseAllocation" />
                    {{ 'IntegrationsClient' | localize }}
                </label>
            </div>
        </div>

        <div class="form-group"
             *ngIf="selectedItem?.provider !== provider.Outlook && !isDevOps(selectedItem) && isClientAllocation()">
            <label>
                {{ 'Client' | localize }}
                <span class="text-danger">*</span>
            </label>
            <select class="form-control rounded-0" [(ngModel)]="selectedClientId">
                <option [ngValue]="undefined">{{ 'SelectClient' | localize }}</option>
                <option *ngFor="let client of clients" [ngValue]="client.id">
                    {{ client.name }}
                </option>
            </select>
        </div>

        <div class="form-group" *ngIf="selectedItem?.authType === authType.ApiKey && !isDevOps(selectedItem) && !isKeka(selectedItem)">
            <label>
                {{ 'IntegrationsApiKey' | localize }}
                <span class="text-danger">*</span>
            </label>
            <input class="form-control rounded-0"
                   type="password"
                   autocomplete="off"
                   [(ngModel)]="apiKey"
                   [placeholder]="'IntegrationsApiKeyPlaceholder' | localize" />
        </div>

        <div class="form-group mb-0" *ngIf="selectedItem?.provider !== provider.Outlook && !isDevOps(selectedItem) && !isKeka(selectedItem)">
            <label>{{ 'Comment' | localize }}</label>
            <textarea class="form-control rounded-0"
                      rows="3"
                      maxlength="1000"
                      [(ngModel)]="comment"
                      [placeholder]="'IntegrationsCommentPlaceholder' | localize"></textarea>
        </div>
    </div>
    <div class="integration-drawer__footer">
        <button type="button"
                class="btn btn-square btn-outline-danger px-5 mr-1"
                (click)="closeConfiguration()"
                [disabled]="connecting">
            {{ 'Cancel' | localize }}
        </button>
        <button type="button"
                class="btn btn-square px-8"
                *ngIf="!(isOutlook(selectedItem) && outlookManageMode)"
                [ngClass]="devOpsDisconnectMode ? 'btn-danger' : 'btn-primary'"
                (click)="connect()"
                [buttonBusy]="connecting"
                [busyText]="l('ConnectingWithThreeDot')">
            {{ (devOpsDisconnectMode ? 'IntegrationsDelink' : 'IntegrationsConnect') | localize }}
        </button>
    </div>
</p-drawer>
